"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addContactEmailSendCodeSaga = exports.addContactEmailSendCodeResponse = exports.addContactEmailSendCode = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const typed_redux_saga_1 = require("typed-redux-saga");
const api_1 = require("../../api");
const apollo_1 = require("../apollo");
const addContactLoadingSlot_1 = require("./addContactLoadingSlot");
const addContactStep_1 = require("./addContactStep");
const addContactWarning_1 = require("./addContactWarning");
exports.addContactEmailSendCode = (0, toolkit_1.createAction)('ADD_CONTACT/EMAIL/SEND_CODE');
exports.addContactEmailSendCodeResponse = (0, toolkit_1.createAction)('ADD_CONTACT/EMAIL/SEND_CODE/RESPONSE');
function* addContactEmailSendCodeSaga({ payload: { email, basePath, redirect }, }) {
    yield* (0, typed_redux_saga_1.put)((0, addContactWarning_1.addContactClearWarnings)());
    yield* (0, typed_redux_saga_1.put)((0, addContactLoadingSlot_1.addContactSetLoadingSlot)({
        slot: addContactLoadingSlot_1.AddContactLoadingSlot.EMAIL_SEND_CODE,
        loading: true,
    }));
    try {
        const apolloClient = yield* (0, typed_redux_saga_1.call)(apollo_1.getApolloClient);
        const response = yield* (0, typed_redux_saga_1.call)(apolloClient.mutate, {
            mutation: api_1.AddContactEmailSendCode,
            variables: {
                email,
                basePath,
                redirect,
            },
        });
        const result = response;
        const isSuccess = result.data?.attachEmailSendMagicLink?.isSuccess;
        const errors = result.errors;
        if (isSuccess) {
            yield* (0, typed_redux_saga_1.put)((0, exports.addContactEmailSendCodeResponse)({ email }));
            yield* (0, typed_redux_saga_1.put)((0, addContactStep_1.addContactSetStep)(addContactStep_1.AddContactStep.EMAIL_AWAIT_CODE));
        }
        else if (errors?.length) {
            const error = errors[0];
            yield* (0, typed_redux_saga_1.put)((0, addContactWarning_1.addContactSetWarning)({
                slot: addContactWarning_1.AddContactWarningSlot.EMAIL_SEND_CODE,
                isValid: false,
                message: error.message,
            }));
        }
        else {
            yield* (0, typed_redux_saga_1.put)((0, addContactWarning_1.addContactSetWarning)({
                slot: addContactWarning_1.AddContactWarningSlot.EMAIL_SEND_CODE,
                isValid: false,
                message: addContactWarning_1.AddContactWarningMessage.EMAIL_SEND_CODE,
            }));
        }
    }
    catch (error) {
        const { message: errorMessage } = error;
        if (errorMessage) {
            yield* (0, typed_redux_saga_1.put)((0, addContactWarning_1.addContactSetWarning)({
                slot: addContactWarning_1.AddContactWarningSlot.EMAIL_SEND_CODE,
                isValid: false,
                message: errorMessage,
            }));
        }
        else {
            yield* (0, typed_redux_saga_1.put)((0, addContactWarning_1.addContactSetWarning)({
                slot: addContactWarning_1.AddContactWarningSlot.EMAIL_SEND_CODE,
                isValid: false,
                message: addContactWarning_1.AddContactWarningMessage.EMAIL_SEND_CODE,
            }));
        }
    }
    finally {
        yield* (0, typed_redux_saga_1.put)((0, addContactLoadingSlot_1.addContactSetLoadingSlot)({
            slot: addContactLoadingSlot_1.AddContactLoadingSlot.EMAIL_SEND_CODE,
            loading: false,
        }));
    }
}
exports.addContactEmailSendCodeSaga = addContactEmailSendCodeSaga;
